<template>
    <div>
        <el-dialog :visible.sync="visible" class="doedit" width="960px" :close-on-click-modal="false"
                   :before-close="beforeClose">
            <div slot="title">
                <z-title title="查看预定"></z-title>
            </div>
            <div class="plr-20 content lh-30">
                <orderbase :info="info"></orderbase>
                <template v-if="info.orderWedding&&info.orderWedding.length!=0">
                    <weddingbase :info="info.orderWedding[0]"></weddingbase>
                </template>
                <div class="flex-n fjc mb-10 mt-10">
                    <el-button type="primary" @click="beforeClose">关 闭</el-button>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../../components/ZTitle";
    import Orderbase from "../../component/orderbase";
    import Weddingbase from "../../component/weddingbase";

    export default {
        components: {
            Weddingbase,
            Orderbase,
            ZTitle
        },
        name: "view-book",
        props: {
            visible: Boolean,
            id: String,
        },
        data() {
            return {
                info: {}
            }
        },
        watch: {
            visible(newval, oldval) {
                if(newval)
                this.getData();
            }
        },
        methods: {
            getData() {
                this.$axios.get('/order/orderDetailById/' + this.id).then(res => {
                    console.log('根据id查询订单的信息', res)
                    this.info = res.data;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            beforeClose() {
                this.$emit('update:visible', false)
            },
        }
    }
</script>

<style scoped lang="scss">
    .doedit {
        .el-divider__text {
            font-weight: 700 !important;
            color: #5295e7;
        }
    }
</style>